import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { ShiftsPage } from '@/features/pos/shifts/shifts-list-page'

export const Route = createFileRoute('/_dashboard/shifts/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ShiftsIndex,
})

function ShiftsIndex() {
  return <ShiftsPage selectedId={undefined} />
}
